/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { CalendarGrid as CalendarGridCore, type CalendarGridProps as CalendarGridCoreProps, type ContextValue, useContextProps } from 'react-aria-components';

interface CalendarGridProps extends Omit<CalendarGridCoreProps, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const CalendarGridContext = createContext<ContextValue<CalendarGridProps, HTMLTableElement>>({});

const CalendarGrid = forwardRef((props: CalendarGridProps, ref: ForwardedRef<HTMLTableElement>) => {
  [props, ref] = useContextProps(props, ref, CalendarGridContext);

  // Long is the default style for weekdays, as we do not use narrow, which is the default style for weekdays in the core component.
  const { style, children, weekdayStyle = 'long', ...coreProps } = props;

  return (
    <CalendarGridCore
      ref={ref}
      weekdayStyle={weekdayStyle}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      {children}
    </CalendarGridCore>
  );
});

const styles = stylex.create({
  base: {
    borderCollapse: 'collapse',
    borderSpacing: 0,
  },
});

export { CalendarGrid, CalendarGridContext, type CalendarGridProps };
